export { AddFundsModalController as AddFundsModal, useAddFundsModal } from './add-funds-modal-controller';
